import React, { Fragment } from "react";
import Routers from "./Routes/index";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <Fragment>
      <Routers />
      <ToastContainer/>
    </Fragment>
  );
}

export default App;
